import React from 'react';
import ToolSectionTitle from 'components/Tools/ToolSectionTitle';
import SwitchButton from 'components/common/SwitchButton';
import { useStore, StoreTypes } from 'context';
import { EventBus } from 'events/EventBus';
import { ReaderToolsEvent } from 'events/EventTypes';

const OptimizePerformance = () => {
  const [{ optimizePerformance }] = useStore(StoreTypes.reader);

  const onChangeHandler = val => {
    EventBus.emit({ event: ReaderToolsEvent.SetOptimizePerformance, payload: { optimizePerformance: val } })
  }
  
  return (
    <div>
      <ToolSectionTitle label="便利貼內容預覽" />
      <SwitchButton value={optimizePerformance} onChange={val=>onChangeHandler(val)}/>
    </div>
  )
};

export default OptimizePerformance;
